import { fetchAPINoID } from "../config";

export async function getAnnouncementDetail(id) {
  let req = {};
  req.Guid = id;
  const data = await fetchAPINoID("/ssm_api_tree/getannoucementdetail", req);
  return data.Data;
}
